import styled from 'styled-components'

export const Error = styled.span.attrs({
  className: 'form-error'
})`
  display: block;
  font-size: 14px;
  line-height: 1;
  font-style: italic;
  font-weight: ${props => props.theme.font.light};
  color: ${props => props.theme.palette.state.danger};
`
